import { useDataBufferContext } from "../context/useDataBuffer.js";
const useRowDividerActions = (rowIndex, recordId) => {
  const { buffer } = useDataBufferContext();
  const onAddRow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!rowIndex && rowIndex !== 0)
      return;
    const insertPosition = rowIndex + 1;
    if (buffer) {
      buffer.updateCell({
        row: insertPosition - 1,
        // Target position for the new row
        column: 0,
        // First column
        ghost: true,
        // This is a new row
        value: "",
        // Empty value
        insertAfter: recordId
        // Insert after this record
      });
    }
  };
  return { onAddRow };
};
export {
  useRowDividerActions
};
